import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/trener-personalny-lodz/client/TrainerSectionClient.tsx");
